import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { TranslatedText } from '..';

import { NoMarginBottom } from './UniversitySelect.styles';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';

interface UniversitySelectProps {
  objName: string;
}
export const UniversitySelect: React.FC<UniversitySelectProps> = ({ objName }) => {
  const form = Form.useFormInstance();
  const selectedBranch = Form.useWatch(['userInfo', objName, 'studyBranch'], form);
  const selectedDegree = Form.useWatch(['userInfo', objName, 'degree'], form);
  const selectedUniversity = Form.useWatch(['userInfo', objName, 'university'], form);
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const { getUniversityOptions } = useUniStudyBranchesOptions();
  const options = getUniversityOptions(selectedBranch, selectedDegree, t('OTHER'));

  return (
    <Box flexDirection="column" gap={12}>
      <TranslatedText i18nKey="UNIVERSITY_GOAL" />
      <NoMarginBottom $isOther={selectedUniversity === 'other'}>
        <Form.Item rules={[RULES.REQUIRED]} name={['userInfo', objName, 'university']}>
          <Select
            options={options}
            placeholder={t('SELECT_UNIVERSITY')}
            disabled={!selectedDegree}
            onChange={() => {
              form.setFieldValue(['userInfo', objName, 'otherUniversity'], undefined);
            }}
          />
        </Form.Item>
      </NoMarginBottom>
      {selectedUniversity === 'other' && (
        <Form.Item
          rules={[
            { required: true, message: t('FIELD_REQUIRED') },
            {
              validator: (_, value) => {
                if (selectedUniversity === 'other' && !value) {
                  return Promise.reject();
                }
                return Promise.resolve();
              }
            }
          ]}
          name={['userInfo', objName, 'otherUniversity']}>
          <Input placeholder={t('OTHER_UNIVERSITY_PLACEHOLDER')} />
        </Form.Item>
      )}
    </Box>
  );
};
